import { assert } from './assert'

export function ensureQuerySelector<T extends Element>(selector: string): T {
  const $element = document.querySelector<T>(selector)
  assert($element, `\`${selector}\` not found`)

  return $element
}
